// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__rDznN","boxTitle":"Qualiphy_boxTitle__WI7WK","box":"Qualiphy_box__2AW0G","toggleWrap":"Qualiphy_toggleWrap__3dE-6"};